/**
 * Workspace ID hook for mutations.
 *
 * Returns the current workspace's `_id` from URL context so callers
 * can merge it into mutation args.
 *
 * @example
 * ```ts
 * const workspaceId = useWorkspaceId();
 * await mutation.mutateAsync({ ...args, workspaceId });
 * ```
 */

import { useWorkspace } from "@/routes/$workspaceSlug/route";
import type { Id } from "convex/_generated/dataModel";

/**
 * Returns the current workspace ID from URL context.
 * Must be called inside a `/$workspaceSlug/*` route.
 */
export function useWorkspaceId(): Id<"workspaces"> {
  const { workspace } = useWorkspace();
  return workspace._id;
}
